<template>
  <div class="bio-container">
    <div class="bio-box">
      <img :src="checkUrl" alt="Foto de perfil do usuário"/>
      <div class="bio-icon-box none">
        <img src="../../../static/img/trash-outline.svg" alt="ícone de lixo"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageFrame',
  data() {
    return {
      actualImgUrl: String
    }
  },
  props: {
    url: String
  },
  computed: {
    checkUrl() {
      if (this.url.length <= 27) {
        this.actualImgUrl = require('../../../static/img/profile.png')
      } else {
        this.actualImgUrl = this.url
      }
      return this.actualImgUrl
    }
  }
}
</script>

<style scoped>
.bio-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bio-box {
  position: relative;
  top: 0;
  left: 0;
  max-width: 99%;

  display: flex;
  margin: 20px 0 0 0;
  width: 207px;
  height: 224px;
  border: 3px dashed #CCCCCC;
  border-radius: 18px;
  opacity: 1;
}

.bio-box > img {
  position: relative;
  top: 0;
  left: 0;

  max-width: 95%;
  max-height: 75%;
  margin: auto;
  border-radius: 10px;
  border: 1px solid var(--color-707070);
  background: transparent 0 0 no-repeat padding-box;
  opacity: 1;
}

.bio-icon-box {
  position: absolute;
  top: 170px;
  left: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 36px;
  background: var(--color-ffffff) 0 0 no-repeat padding-box;
  border: 1px solid #CCCCCC;
  border-radius: 10px;
  opacity: 1;
}

.bio-icon-box > img {
  width: 17px;
  height: 18px;
  filter: invert(41%) sepia(23%) saturate(2886%) hue-rotate(326deg) brightness(99%) contrast(88%);
}

</style>



// WEBPACK FOOTER //
// ImageFrame.vue?367cd4f4